module.exports = __webpack_public_path__ + "static/media/spinner.d6494e63.png";